export default __webpack_public_path__ + "static/media/boomsell1.7509eb25.png";